import React, {Component} from "react";
import {compose} from "redux";
import {withTranslation} from "react-i18next";

import * as Yup from "yup";
import FormElementContainer from "../../../../components/forms_builder/FormElementContainer";
import RequestMedicalInfo from "../../../../components/Patient_requests_compopnents/RequestMedicalInfo";
import RequestUpdateFiles from "../../../../components/Patient_requests_compopnents/RequestUpdateFiles";
import SelfUpdateFiles from "../../../../components/Patient_SelfOnboard/SelfUpdateFiles";
import LeumitSelfOtherMedicalInfo from "../../../../components/Leumit_Patient_SelfOnboard/LeumitSelfOtherMedicalInfo";
import RequestOtherMedicalInfo from "../../../../components/Patient_requests_compopnents/RequestOtherMedicalInfo";
import DoctorsReferral from "../../../../components/PatientOnboard/DoctorsReferral";
import LeumitDoctorsReferral from "../../../../components/Leumit_Patient_SelfOnboard/LeumitDoctorsReferral";
import LeumitSelfUpdateFiles from "../../../../components/Leumit_Patient_SelfOnboard/LeumitSelfUpdateFiles";


const validationSchema = Yup.object().shape({
 /*   Recommendation_letter_use_cannabis:Yup.string().nullable().required('This field is mandatory'),
    Psychiatric_diagnosis:Yup.string().nullable().required('This field is mandatory'),
    Current_psychosis:Yup.string().nullable().required('This field is mandatory'),
    Past_psychosis:Yup.string().nullable().required('This field is mandatory'),
    Nuclear_family_psychosis:Yup.string().nullable().required('This field is mandatory'),
    Drug_abuse:Yup.string().nullable().required('This field is mandatory'),
    Cardiovascular_history:Yup.string().nullable().required('This field is mandatory'),
    Cardiovascular_risk:Yup.string().nullable().required('This field is mandatory'),
    Lung_disease:Yup.string().nullable().required('This field is mandatory'),*/
})

class RequestMedicalInfoTabComposed extends Component {
    constructor(props) {
        super(props);
        this.state = {
        };
    }


     componentWillMount() {
        this.props.initValidation(validationSchema)
    }

    onValueChange = (name,value) => {
        this.props.onValueChange(name,value)
    }
    onYesNoValueChange = (name,value) => {
        this.props.onYesNoValueChange(name,value)
    }
    onclickSetIsOtherMedicalDiagnosis = () => {
        this.props.onclickSetIsOtherMedicalDiagnosis()
    }
    onClickMedicationConditions = (value) => {
        this.props.onClickMedicationConditions(value)
    }
    onClickPatientAllergics = (value) => {
        this.props.onClickPatientAllergics(value)
    }
    onClickAddDeleteMedications = (index,event,id,type) => {
        this.props.onClickAddDeleteMedications(index,event,id,type)
    }
    addDeleteMedication = (func,index) => {
        this.props.addDeleteMedication(func,index)
    }
    saveSelectedFile = (selectedFile,index) => {
        this.props.saveSelectedFile(selectedFile,index)
    }

    deleteLeumitUploadedFile=(index,fileIndex,fileName) => {
        this.props.deleteLeumitUploadedFile(index,fileIndex,fileName)
    }

    deleteUploadedFile=(index) => {
        this.props.deleteUploadedFile(index)
    }

    render() {
        let {t} = this.props

        return (
            <div  className={'patientForm-box-container'}>

                <FormElementContainer title={t('patient_self_boarding.Medical_information')}
                                      Component={RequestMedicalInfo}
                                      rest={{
                                          onYesNoValueChange:(name, value) => this.onYesNoValueChange(name, value),
                                          onValueChange:(name,value) => this.onValueChange(name,value),
                                          entry:this.props.entry,
                                          requestFromVisit:this.props.requestFromVisit,
                                          onClickPatientAllergics:(val) =>this.onClickPatientAllergics(val),
                                          patient_allergics:this.props.patient_allergics,
                                          allergics:this.props.allergics,
                                          onClickMedicationConditions:(value) => this.onClickMedicationConditions(value),
                                          medicalConditions:this.props.medicalConditions,
                                          medicalConditionsSelected:this.props.medicalConditionsSelected,
                                          errors:this.props.errors,
                                          t:(e) => this.props.t(e)
                                      }}/>

                <FormElementContainer title={t('patient_self_boarding.Other_Medical_information')}
                                      Component={RequestOtherMedicalInfo}
                                      rest={{
                                          onYesNoValueChange:(name, value) => this.onYesNoValueChange(name, value),
                                          onValueChange:(name,value) => this.onValueChange(name,value),
                                          entry:this.props.entry,
                                          requestFromVisit:this.props.requestFromVisit,
                                          errors:this.props.errors,
                                          t:(e) => this.props.t(e)
                                      }}/>




                <FormElementContainer title={t('patient_self_boarding.upload_files')}
                                      Component={LeumitSelfUpdateFiles}
                                      rest={{
                                          entry:this.props.entry,
                                          filesToUpload:this.props.filesToUpload,
                                          fileForms:this.props.fileForms,
                                          t:(e) => this.props.t(e),
                                          addFileObj: (index, selectedCategory, selectedFile) => this.props.addFileObj(index, selectedCategory, selectedFile),
                                          isUploadingFiles:this.props.isUploadingFiles,
                                          onValueChange:(name,value) => this.onValueChange(name,value) ,
                                          saveSelectedFile:(selectedFile,index) => this.saveSelectedFile(selectedFile,index),
                                          deleteUploadedFile:(index) => this.deleteUploadedFile(index),
                                          deleteLeumitUploadedFile:(index,fileIndex,fileName) => this.deleteLeumitUploadedFile(index,fileIndex,fileName),
                                          addedFilesList:this.props.addedFilesList,
                                          otherForms:this.props.otherForms,
                                          errors:this.props.errors,
                                      }}/>

            </div>
        );
    }
}



const LeumitRequestMedicalInfoTab = compose(
    withTranslation(),
    /*connect(
        mapStateToProps,
        mapDispatchToProps
    )*/
)(RequestMedicalInfoTabComposed);

export default LeumitRequestMedicalInfoTab;

